export default __webpack_public_path__ + "star-regular-brown-for-home.0c1c9fcb.svg";